<template>
  <a-layout>
    <course-selection-progress :active.sync="active"/>
    <fixed-course-selection v-show="active===1"/>
    <draw-course-selection  v-show="active===2"/>
    <all-courses-selection  v-show="active===3"/>
    <selected-courses       v-show="active===4"/>
  </a-layout>
</template>

<script>
import DrawCourseSelection from "@/components/Outline/Progress/DrawCourseSelection";
import AllCoursesSelection from "@/components/Outline/Progress/AllCoursesSelection";
import FixedCourseSelection from "@/components/Outline/Progress/FixedCourseSelection";
import CourseSelectionProgress from "@/components/Outline/Progress/CourseSelectionProgress";
import SelectedCourses from "@/components/Outline/Progress/SelectedCourses";

export default {
  name: "CourseClassifiedList",
  components: {
    SelectedCourses,
    CourseSelectionProgress,
    FixedCourseSelection,
    AllCoursesSelection,
    DrawCourseSelection},
  data() {
    return {
      active: 1
    }
  },
  methods:{
  }
}
</script>

